export const styleCellTitle = {
  lineHeight: '130%',
  fontWeight: 900
};

export const stickyCellRight = {
  position: 'sticky',
  right: 0,
  backgroundColor: 'grey.100',
  zIndex: 1
};

export const stickyCellBottom = {
  position: 'sticky',
  bottom: 0,
  backgroundColor: 'grey.100',
  zIndex: 1
};
